import Text from "_shared/text/text";

export default class ProjectDescription extends Text {
  public static create(value: ProjectDescription | string): ProjectDescription {
    if (value instanceof ProjectDescription) {
      return value;
    }
    return new ProjectDescription(value);
  }

  public static override fromJSON(
    value: string | object | boolean | number | null | undefined
  ): ProjectDescription | null | undefined {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new Error("Cannot create ProjectDescription from non-string value");
    return new ProjectDescription(value);
  }
}
